import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';

import UploadCard from '../Widgets/UploadCard';
import ExportButton from '../Widgets/ExportButton';
import Summary from '../Widgets/Summary';
import { importExportContext } from '../../context/importExportContext';

const UploadSummary = (param) => {
  switch(param.flag){
    case -1:
      return null;
    case 1:
      return <Summary title="Upload Summary" body={param.body} type="primary"/>
    case 0:
      return <Summary title="Upload Error" body={param.body} type="secondary"/>
    default:
      return null;
  }
}

const UploadPageContainer = (props) => {
  const [isUploadSuccess, setUploadStatus] = useState(-1);
  const [uploadSummary, setUploadSummary] = useState([]);

  return (
    <div className="pda-upload-grid-wrapper">
      <Grid container justifyContent={props.showUploadCard ? "center" : "flex-start"} data-testid="grid-container">
        <Grid item xs={6} data-testid="grid-item">
          <importExportContext.Provider value={{
              isUploadSuccess,
              uploadSummary,
              setUploadStatus: (status) => setUploadStatus(status),
              setUploadSummary: (data) => setUploadSummary(data),
            }}>
            <div className="pda-upload-container">
              { props.showUploadCard ? <UploadCard from={props.from} /> : null }
              <ExportButton
                className={props.showUploadCard ? "pda-upload-button with-card" : "pda-upload-button" }
                from={props.from}
                buttonText={props.buttonText}
              />
              <UploadSummary flag={isUploadSuccess} body={uploadSummary} />
            </div>
          </importExportContext.Provider>
        </Grid>
      </Grid>
    </div>
  )
}

export default UploadPageContainer;
